import { useLocation } from 'react-router-dom';
import { buscarTodosPontosDeMototaxi } from '../servicos/listagemServico';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { useEffect, useState } from 'react';
import L from 'leaflet';
import Cookies from 'js-cookie';
import { aplicarMascaraTelefone } from '../uteis/mascaras/mascaraTelefone';
import LoadingIndicator from '../components/LoadingIndicator'
import { useNavigate } from 'react-router-dom';

function VisualizarTodosOsPontosNoMapa() {

  const [loadingIndicator, setLoadingIndicator] = useState(true);
  const [mostrarModalLocalidades, setMostrarModalLocalidades] = useState(false);
  const [localidadesAtendidasSelecionadas, setLocalidadesAtendidasSelecionadas] = useState([]);
  const navigate = useNavigate();

  // useEffect(() => {
  //   console.log('Removendo dadosCookies ao entrar no MapaAtual.js...');
  //   Cookies.remove('dadosCookies');
  // }, []);

  const BASE_URL =
    window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
      ? 'http://127.0.0.1:8000' 
      : 'https://mercadinhointeligente.com.br';

  const [posicao, setPosicao] = useState(null);
  const [pontosProximos, setPontosProximos] = useState([]);
  const location = useLocation();
  const servicoSelecionado = location.state?.servicoSelecionado || null;

  const cookies = Cookies.get();
  const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;

  const [mostrarModal, setMostrarModal] = useState(false);
  const [pontoSelecionado, setPontoSelecionado] = useState(null);

  const [telefone, setTelefone] = useState('');
  const [enderecoOrigem, setEnderecoOrigem] = useState('');
  const [enderecoDestino, setEnderecoDestino] = useState('');

  console.log('dadosCookies: ');
  console.log(dadosCookies);

  const iconeMoto = new L.Icon({
    iconUrl: '/imagens/icones/moto-verde-esportiva.png',
    iconSize: [55, 55],
  });

  const iconeUsuario = new L.Icon({
    iconUrl: '/imagens/icones/boneco1.png',
    iconSize: [65, 65],
  });


  const abrirModalLocalidades = (localidades) => {

    console.log('Entrou em abrirModalLocalidades...');
    console.log(localidades);

    setLocalidadesAtendidasSelecionadas(localidades || []);
    setMostrarModalLocalidades(true);
  };



  // Pegar localização atual
  useEffect(() => {
    console.log('Entrou no useEffect do MapaAtual.js...');

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const coords = [pos.coords.latitude, pos.coords.longitude];
        setPosicao(coords);
      },
      (err) => {
        console.error('Erro ao obter localização:', err);
        alert('Não foi possível obter a sua localização. Tente novamente.');
        navigate('/pagina-adm-tecnico');
      }
    );
  }, []);


  // Buscar pontos via API quando posição for conhecida
  useEffect(() => {
    console.log('Entrou no useEffect 2 do MapaAtual.js...');
    console.log('Preparando para carregar os ponto próximos...');

    const carregarPontos = async () => {
      setLoadingIndicator(true);
      if (posicao) {
        try {
          const dados = {
            latitude: posicao[0],
            longitude: posicao[1],
            servico_id: servicoSelecionado?.id ?? null
          };

          console.log('Dados do internauta que está acessando agora: ');
          console.log(dados);

          const dadosInternauta = {
            'dadosInternauta': dados,
          };

          const novosDadosCookies = {
            ...dadosCookies,
            ...dadosInternauta
          };

          console.log('Vamos adicionar aos cookies, a localização do usuário.... ');
          Cookies.set('dadosCookies', JSON.stringify(novosDadosCookies), { expires: 7 });
          console.log('ok, localização adicionada.');

          const resposta = await buscarTodosPontosDeMototaxi(dados);
          console.log('Resposta: ');
          console.log(resposta.dados);

          setPontosProximos(resposta.dados);
        } catch (error) {
          console.error('Erro ao buscar pontos próximos:', error);
        } finally {
          setLoadingIndicator(false);
        }
      }
    };

    carregarPontos();
  }, [posicao, servicoSelecionado]);

  if (!posicao) {
    return <p>Obtendo localização...</p>;
  }

  const abrirModal = (pontoId) => {
    console.log('Abrindo modal para ponto:', pontoId);

    // Preencher telefone caso exista nos cookies
    const cookies = Cookies.get();
    const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;
    const dadosInternauta = dadosCookies?.dadosInternauta || {};

    if (dadosInternauta.numero_celular_com_ddd) {
      setTelefone(dadosInternauta.numero_celular_com_ddd);
    }
    if (dadosInternauta.descricao_endereco_origem) {
      setEnderecoOrigem(dadosInternauta.descricao_endereco_origem);
    }
    if (dadosInternauta.descricao_endereco_destino) {
      setEnderecoDestino(dadosInternauta.descricao_endereco_destino);
    }

    setPontoSelecionado(pontoId);
    setMostrarModal(true);
  };

  const salvarDadosInternauta = () => {
    if (!telefone || !enderecoOrigem) {
      alert('Por favor, preencha o telefone e a origem.');
      return;
    }

    setLoadingIndicator(true);

    console.log('Salvando dadosInternauta nos cookies...');

    const cookies = Cookies.get();
    const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : {};

    const novosDadosInternauta = {
      ...dadosCookies.dadosInternauta,
      numero_celular_com_ddd: telefone,
      descricao_endereco_origem: enderecoOrigem,
      descricao_endereco_destino: enderecoDestino || null
    };

    const novosDadosCookies = {
      ...dadosCookies,
      dadosInternauta: novosDadosInternauta
    };

    Cookies.set('dadosCookies', JSON.stringify(novosDadosCookies), { expires: 7 });
    console.log('DadosInternauta salvos com sucesso:', novosDadosInternauta);

    setMostrarModal(false);
    setLoadingIndicator(false);
    window.location.href = `/solicitar-servico/${pontoSelecionado}`;
  };


  // Se ainda estiver carregando inicial, mostra spinner
  if (loadingIndicator) {
    return <LoadingIndicator fullscreen message="Aguarde..." />;
  }



  return (
    <>
      

{mostrarModalLocalidades && (

<div
  className="modal fade show d-block"
  tabIndex="-1"
  role="dialog"
  style={{ backgroundColor: "rgba(0,0,0,0.6)" }}
>
  <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div className="modal-content shadow-lg border-0 rounded-4">
      {/* Cabeçalho */}
      <div className="modal-header bg-primary text-white rounded-top-4">
        <h5 className="modal-title fw-bold">
          <i className="bi bi-geo-alt-fill me-2"></i> Localidades Atendidas
        </h5>
        <button
          type="button"
          className="btn-close btn-close-white"
          onClick={() => setMostrarModalLocalidades(false)}
        ></button>
      </div>

      {/* Corpo */}
      <div className="modal-body p-4">
        {localidadesAtendidasSelecionadas.length === 0 ? (
          <p className="text-muted text-center">
            <i className="bi bi-info-circle me-2"></i>
            Nenhuma localidade registrada.
          </p>
        ) : (
          <div className="table-responsive">
            <table className="table table-hover align-middle text-center">
              <thead className="table-primary">
                <tr>
                  <th>Nome</th>
                  <th>Valor <br /><small>(06h às 23h)</small></th>
                  <th>Valor <br /><small>(23h às 06h)</small></th>
                </tr>
              </thead>
              <tbody>
                {localidadesAtendidasSelecionadas.map((loc, index) => (
                  <tr key={index}>
                    <td className="fw-semibold text-start">
                      <i className="bi bi-geo me-2 text-primary"></i>
                      {loc.nome} - {loc.cidade}/{loc.uf}
                    </td>
                    <td className="text-success fw-bold">
                      R$ {parseFloat(loc.valor_6_as_23).toFixed(2)}
                    </td>
                    <td className="text-danger fw-bold">
                      R$ {parseFloat(loc.valor_23_as_6).toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Rodapé */}
      <div className="modal-footer border-0">
        <button
          type="button"
          className="btn btn-secondary px-4"
          onClick={() => setMostrarModalLocalidades(false)}
        >
          <i className="bi bi-x-circle me-2"></i> Fechar
        </button>
      </div>
    </div>
  </div>
</div>


  )}



{mostrarModal && (
  <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div className="modal-content shadow-lg border-0">
        <div className="modal-header border-0">
          <div>
            <h5 className="modal-title fw-bold">Informe seus dados</h5>
            <small className="text-muted">Assim o piloto te localiza mais rápido</small>
          </div>
          <button
            type="button"
            className="btn-close"
            onClick={() => setMostrarModal(false)}
          ></button>
        </div>

        <div className="modal-body">
          <div className="mb-3">
            <label htmlFor="telefone" className="form-label">
              Seu celular <span className="text-danger">*</span>
            </label>
            <div className="input-group">
              <span className="input-group-text">📱</span>
              <input
                type="tel"
                id="telefone"
                className="form-control"
                value={telefone}
                onChange={(e) => {
                  const valorFormatado = aplicarMascaraTelefone(e.target.value);
                  setTelefone(valorFormatado);
                }}
                placeholder="(XX) XXXXX-XXXX"
              />
            </div>
            {/* <div className="form-text">Coloque o DDD e o número com 8 ou 9 dígitos</div> */}
          </div>

          <div className="mb-3">
            <label htmlFor="endereco_origem" className="form-label">
              Endereço onde você está agora <span className="text-danger">*</span>
            </label>
            <div className="input-group">
              <span className="input-group-text">📍</span>
              <input
                type="text"
                id="endereco_origem"
                className="form-control"
                value={enderecoOrigem}
                onChange={(e) => setEnderecoOrigem(e.target.value)}
                placeholder="Ex: Rua 01 ao lado do supermercado..."
              />
            </div>
          </div>

          <div className="mb-3">
            <label htmlFor="endereco_destino" className="form-label">
              Endereço de destino <span className="text-danger">*</span>
            </label>
            <div className="input-group">
              <span className="input-group-text">🧭</span>
              <input
                type="text"
                id="endereco_destino"
                className="form-control"
                value={enderecoDestino}
                onChange={(e) => setEnderecoDestino(e.target.value)}
                placeholder="Ex: Rodoviária..."
              />
            </div>
          </div>
        </div>

        <div className="modal-footer border-0">
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={() => setMostrarModal(false)}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={salvarDadosInternauta}
          >
            Salvar e continuar
          </button>
        </div>
      </div>
    </div>
  </div>
)}



      <div style={{ height: 'calc(100vh - 110px)' }}>
        <MapContainer center={posicao} zoom={5.2} style={{ flex: 1, height: '100%', width: '100%' }}>
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution="© OpenStreetMap contributors"
          />

          <Marker position={posicao} icon={iconeUsuario}>
            <Popup><h2>Você está aqui</h2></Popup>
          </Marker>

          {pontosProximos.map((ponto) => {
            const imagemLogomarca = `${BASE_URL}/storage/imagens/pontoMotoTaxi/logomarca_ponto_mototaxi_${ponto.id}.png`;

            console.log('ponto: ');
            console.log(ponto);

            console.log('localidades atendidas: ');
            console.log(ponto.localidadesAtendidas);

            const iconeCustomizado = imagemLogomarca
              ? new L.DivIcon({
                html: `
                  <div style="
                  width: 65px;
                  height: 55px;
                  border: 2px solid black;
                  border-radius: 6px;
                  overflow: hidden;
                  box-shadow: 0 0 4px rgba(0,0,0,0.4);
                  ">
                  <img src="${imagemLogomarca}" style="
                      width: 100%;
                      height: 100%;
                      object-fit: contain;
                      display: block;
                  " />
                  </div>
                `,
                iconSize: [42, 42],
                iconAnchor: [21, 42],
                popupAnchor: [0, -42],
                className: ''
              })
              : iconeMoto;

            return (
              <Marker
                key={ponto.id}
                position={[ponto.latitude, ponto.longitude]}
                icon={iconeCustomizado}
              >
                <Popup>
                  <div style={{ textAlign: 'center' }}>
                    <strong>{ponto.nome_ponto}</strong><br />
                    {ponto.endereco}<br />

                    {imagemLogomarca && (
                      <img
                        src={imagemLogomarca}
                        alt="Logomarca"
                        style={{
                          width: '100px',
                          height: '100px',
                          objectFit: 'contain',
                          margin: '8px auto',
                          borderRadius: '6px',
                          border: '4px solid black'
                        }}
                      />
                    )}
                    
                      <>
                        <hr />
                        <strong>Valor de 6h às 23h:</strong><br />
                        <span>R$ {ponto?.servicoAtendido?.valor_6_as_23}</span><br />
                        <strong>Valor de 23h às 6h:</strong><br />
                        <span>R$ {ponto?.servicoAtendido.valor_23_as_6}</span><br />                      
                      </>                    

                    <hr />

                    {/* <button
                      onClick={() => abrirModal(ponto.id)}
                      style={{
                        marginTop: '10px',
                        padding: '6px 12px',
                        backgroundColor: '#28a745',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer'
                      }}
                    >
                      Solicitar serviço
                    </button> */}
                  </div>
                </Popup>
              </Marker>
            );
          })}
        </MapContainer>
      </div>
    </>
  );
}

export default VisualizarTodosOsPontosNoMapa;
